import { PaletteMode } from "@mui/material";

export const colors = {
  // App
  black: "#272727",
  white: "#FFFFFF",
  grey: "#252126",
  lightGrey: "#D9D9D9",
  darkGrey: "#888888",
  green: "#7AC824",
  darkGreen: "#5d991d",
  brown: "#231F24",
  lightBrown: "#48424B",
  purple: "#524b55",
  lightPurple: "#706675",
  capuccino: "#F2ECE7",
  semiDarkCapuccino: "#d1ccc7",
  darkCapuccino: "#36332d",
  // Social
  facebook1: "#0064E6",
  facebook2: "#1AABFE",
  instagram1: "#5E55CD",
  instagram2: "#DF3475",
  // Theme mode
  darkYellow: "#e0c600",
  yellow: "#ffe100",
  red: "#c50000",
  orange: "#d36600",
  // Text gradient
  gradientFromLight: "#2F2A31",
  gradientToLight: "rgba(47, 42, 49, 0.27)",
  gradientFromDark: "#cdb8d4",
  gradientToDark: "rgba(194, 176, 202, 0.27)"
};

export const statusColors: Record<PaletteMode, Record<string, string>> = {
  light: {
    statusInfoBackground: "#D9EBFB",
    statusInfoText: "#5C84A8",
    statusSuccessBackground: "#E7FAF5",
    statusSuccessText: "#688D84",
    statusWarningBackground: "#FFF4E5",
    statusWarningText: "#9C825F",
    statusErrorBackground: "#FDE9E9",
    statusErrorText: "#9B6C6C"
  },
  dark: {
    statusInfoBackground: "#1E3A52",
    statusInfoText: "#87B3D9",
    statusSuccessBackground: "#1A3D32",
    statusSuccessText: "#7DB3A8",
    statusWarningBackground: "#3D2E1A",
    statusWarningText: "#C4A572",
    statusErrorBackground: "#3D1F1F",
    statusErrorText: "#C48A8A"
  }
};

export const tileColors = {
  beige: "#F2ECE7",
  brown: "#674747",
  red: "#B31312",
  green: "#829460",
  yellow: "#F8DE22",
  blue: "#1450A3",
  white: "#FFFFFF",
  black: "#272727",
  gray: "#A8A196"
};
